module.exports = __webpack_public_path__ + "img/ktc.53a16ddf.png";